import { FonteIdadeGestacionalEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

export function calcularFonteIgRecomendada(igDum: number, igEco?: number): FonteIdadeGestacionalEnum {
  if (isUndefinedOrNull(igEco) || isUndefinedOrNull(igDum)) {
    return FonteIdadeGestacionalEnum.DUM
  }

  const diferencaDias = Math.abs(igEco - igDum)
  const referenciaDiferencaDias = calcularDiferencaDiasReferencia(igEco)

  return decideFontePorDiferencaDeDias(diferencaDias, referenciaDiferencaDias)
}

function decideFontePorDiferencaDeDias(diferencaDias: number, diasReferencia: number): FonteIdadeGestacionalEnum {
  return diferencaDias <= diasReferencia ? FonteIdadeGestacionalEnum.DUM : FonteIdadeGestacionalEnum.US
}

export function calcularDiferencaDiasReferencia(igEco: number): number {
  const diasSemana = 7
  if (igEco <= 8 * diasSemana + 6) {
    return 5
  }
  if (igEco <= 15 * diasSemana + 6) {
    return 7
  }
  if (igEco <= 21 * diasSemana + 6) {
    return 10
  }
  if (igEco <= 27 * diasSemana + 6) {
    return 14
  }
  return 21
}
